import { useContext } from "react";

import { ContextSupportMessenger } from "./support_messenger.context";

export const useContextSupportMessenger = () =>
  useContext(ContextSupportMessenger);
